import { BitfODataResponseMapper } from '@bitf/core/parsers/odata-parser/bitf-odata-response.mapper';

export class AppResponseMapper extends BitfODataResponseMapper {}
